import React from 'react'
import styled from 'styled-components'

const FormWrapper = styled.form`
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0.5em;
    font-size: 1.25em;

    & input {
        padding: 0.5em;
        border: 0;
        border-bottom: #999999 solid 0.05em;
        background:none;
        font-size: 1em;
    }

    & input::placeholder {
        color: rgba(85,85,85,0.5);
    }

    & label {
        display: flex;
        color: #999999;
        justify-content: flex-start;
        opacity: 0.5;
    }

    & label > span:nth-child(2) {
        margin-left: 0.1em;
        margin-right: 0.1em;
    }  
`

const Form = props => <FormWrapper {...props}>{props.children}</FormWrapper>

export default Form
